import React from 'react';
import PropTypes from 'prop-types';
import FilterPill from '../filterpill/FilterPill';
import filterDefinitionPropType from '../../../filterDefinitionPropType';

const renderValue = (value, filterDefinition) => {
    if (!value) {
        return (filterDefinition && filterDefinition.radio) ? 'None' : 'All';
    }

    return value.length > 49 ? `${value.substring(0, 50)}...` : value;
};

const StringFilterPill = (props) => (
    <FilterPill
        fixed={ props.fixed }
        disabled={ props.disabled }
        filter={ props.filter }
        filterError={ props.filterError }
        displayValue={ renderValue(props.filter.value, props.filterDefinition) }
        isOpen={ props.isOpen }
        openFilter={ props.openFilter }
        removeFilter={ props.removeFilter }
        updateFilter={ props.updateFilter }
    />
);

StringFilterPill.propTypes = {
    fixed: PropTypes.bool,
    disabled: PropTypes.bool,
    filter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    }).isRequired,
    filterError: PropTypes.shape({}),
    isOpen: PropTypes.bool,
    openFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    filterDefinition: filterDefinitionPropType
};

StringFilterPill.defaultProps = {
    fixed: false,
    isOpen: false,
    filterError: null,
    disabled: false,
    filterDefinition: null
};

export default StringFilterPill;
